 export let SAVE_FORM = "SAVE_FORM";


 export let ARTICLE_SVE = "ARTICLE_SVE";


 export let GET_FORMS = "GET_FORMS";

 export let DELETE_FORM = "DELETE_FORM";

 export let FORM_UPDATE = "FORM_UPDATE";


 export let SAVE_SIGNUP = "SAVE_SIGNUP";

 export let GET_AUTH = "GET_AUTH";        // login


 export let DUPERR_MSG = "DUPERR_MSG";

export let DATA_LOGIN = "DATA_LOGIN";

export let LOGOUT = "LOGOUT";

export let ISTOKEN_OK = "ISTOKEN_OK";

export let MSG_LOGINS = "MSG_LOGINS";


export let FORG_PASS = "FORG_PASS";

export let FORG_PASSERR = "FORG_PASSERR";



export let UPDATEPASS_MSG = "UPDATEPASS_MSG";


export let CLEAR_STATE = "CLEAR_STATE";

export let ISTOKEN_OKTOEDIT = "ISTOKEN_OKTOEDIT";

export let UPVOTE_SET = "UPVOTE_SET";

export let DOWNVOTE_SET = "DOWNVOTE_SET";

export let ISUSER_VOTED = "ISUSER_VOTED";

//////////////////////////////////////////////
export let SET_SNACKBAR = "SET_SNACKBAR";
export let SITE_GENRL = "SITE_GENRL";
export let GETSITE_GENRL = "GETSITE_GENRL";
export let SITE_SOCIALS = "SITE_SOCIALS";
export let LOGOUT_USER = "LOGOUT_USER";

export let HOME_BANER = "HOME_BANER";

export let NFT_PROMOT = "NFT_PROMOT";
export let NFT_RECENT = "NFT_RECENT";
export let NFT_POPULAR = "NFT_POPULAR";

export let NFT_BANNER = "NFT_BANNER";

export let CREATE_SERVICES = "CREATE_SERVICES";

export let DELETE_SERVICE = "DELETE_SERVICE";

export let UPDATE_SERVICE = "UPDATE_SERVICE";

export let ABOUTUS_DATA = "ABOUTUS_DATA";

export let HOME_DOCS = "HOME_DOCS";
export let UPDATE_DOCS = "UPDATE_DOCS";

export let CREATE_MEMBER = "CREATE_MEMBER";
export let DELETE_MEMBER = "DELETE_MEMBER";
export let UPDATE_MEMBER = "UPDATE_MEMBER";

////////CREATE_BLOGS
export let CREATE_BLOGS = "CREATE_BLOGS";

export let DELETE_BLOG = "DELETE_BLOG";
export let UPDATE_BLOG = "UPDATE_BLOG";

export let CREATE_ROADMAP = "CREATE_ROADMAP";

export let DELETE_ROADMAP = "DELETE_ROADMAP";
export let UPDATE_ROADMAP = "UPDATE_ROADMAP";

export let CREATE_TCKNMX = "CREATE_TCKNMX";

export let DELETE_TOCKENOMCS = "DELETE_TOCKENOMCS";

export let UPDATE_TCKNMICS = "UPDATE_TCKNMICS";
